import * as React from "react";
import {ToastContainer} from "react-toastify";

export const ToastComponent = () => (
    <ToastContainer position={'top-right'} autoClose={5000} hideProgressBar={true} newestOnTop={true}/>
    );